module.exports = __webpack_public_path__ + "static/media/Daniel Murage.4eb774ba.jpeg";